
/** Errors of the material native Validators */
// eslint-disable-next-line @tseslint/typedef
export const NATIVE_FORM_FIELD_ERRORS = {
  /** Throws when input doesn't match a valid email pattern */
  email: "email",
  /** Throws when input gets left empty */
  required: "required"
} as const;
